import { render, staticRenderFns } from "./ReAssignOrder.vue?vue&type=template&id=533b4d10&scoped=true&"
import script from "./ReAssignOrder.vue?vue&type=script&lang=js&"
export * from "./ReAssignOrder.vue?vue&type=script&lang=js&"
import style0 from "./ReAssignOrder.vue?vue&type=style&index=0&id=533b4d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533b4d10",
  null
  
)

export default component.exports